import { useContext } from "react";
import { LayoutStyleContext } from "@/contexts/layout-style-context";

export function useLayoutStyle() {
  const context = useContext(LayoutStyleContext);
  if (!context) {
    throw new Error("useLayoutStyle must be used within a LayoutStyleProvider");
  }
  return context;
}
